// src/index.js
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import Rotas from './routes';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext.js';
import { FavoritesProvider } from './context/FavoritesContext';
import { ToastProvider } from './context/ToastContext';
import { ModoIdosoProvider } from './context/ModoIdosoContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ToastProvider>
        <AuthProvider>
          <CartProvider>
            <FavoritesProvider>
              <ModoIdosoProvider>
                <Rotas />
              </ModoIdosoProvider>
            </FavoritesProvider>
          </CartProvider>
        </AuthProvider>
      </ToastProvider>
    </HelmetProvider>
  </React.StrictMode>
);